/*
 *  I15MASVOLAPHUMLI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-05-29 21:26:16 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15MASVOLAPHUML_SECTION_0_TITLE: 'Calculez la variation du poid du bois en fonction de son humidité',
  I15MASVOLAPHUML_in_massVolApp: 'Masse volumique apparente',
  I15MASVOLAPHUML_in_humiditeRf: 'Humidité de référence',
  I15MASVOLAPHUML_in_humiditeSouhaite: 'Humidité souhaitée',
  I15MASVOLAPHUML_res_massVolBois: 'Masse volumique apparente'
}
